// url sep tools
const urlNotifWs = process.env.VUE_APP_API_NOTIF_WS_URL,
  enableNotif = process.env.VUE_APP_NOTIF_LOG;

const isProd = process.env.NODE_ENV === "production" ? true : false;

class SimrsNotif {
  target: string;
  ws: WebSocket;

  constructor() {
    this.target = "ch.simrs";
    this.ws = new WebSocket(urlNotifWs);
  }

  send(msg: string, flash = 0) {
    /* data:
    // chn: grup angkringan: 'group'; channel simrs@RSUDPS: 'ch.simrs'
    // flash: int detik (buat auto delete setelah ... detik)
    { act: 'hello', chn: 'ch.simrs', msg: 'message to send', 'flash': 5})
    */
    const message =
      `🐞 eMedika message💻${
        !isProd ? "  <strong>!!!DEV!!!</strong>" : ""
      } \r\n` + msg;

    if (enableNotif == "true") {
      this.ws.send(
        JSON.stringify({
          act: "hello",
          chn: this.target,
          msg: message,
          flash: flash
        })
      );
    }
  }

  to(chn: string) {
    this.target = chn;

    return this;
  }

  testParam() {
    console.log("enableNotif", enableNotif, typeof enableNotif);
    console.log("isProd", isProd, typeof isProd);
    console.log("urlNotifWs", urlNotifWs);
  }
}

export default SimrsNotif;
